export enum Memory {
    INTACT = 'Intact',
    IMPAIRED = 'Impaired',
}